import { IS_ARTIST } from '@disco/constants/FeatureTypes'
import {
  ARTIST_PLANS_TAB,
  BUSINESS_PLANS_TAB,
} from '@disco/state-management/reducers/forms/pricing'
import {
  getIsTrial,
  isFeatureEnabled,
} from '@disco/state-management/selectors/business'
import {
  isArtistPlansAvailable,
  isBusinessPlansAvailable,
} from '@disco/state-management/selectors/subscription'
import { ARTIST_ID } from '@disco/utils/featuresAccessLevel'
import type { State } from '../reducers'
import type { ChannelShareFormState } from '../reducers/forms/channel-share'
/**
 * Gets the channel share form state.
 * @param state - The Redux state
 * @returns The channel share form object
 */
export const getChannelShareForm = (state: State): ChannelShareFormState =>
  state.forms.channelShareForm
/**
 * Object containing validation functions for different plan types.
 * Used to check if a user has permissions to access specific plan types.
 */
const validatePlansPermissions = {
  /**
   * Validates if the user can access artist plans.
   * @param state - The Redux state
   * @returns True if user is an artist on trial, false otherwise
   */
  [ARTIST_ID]: state => {
    const artistEnabled = isFeatureEnabled(state, {
      featureName: IS_ARTIST,
    })
    const trial = getIsTrial(state)
    return artistEnabled && trial
  },
}
/**
 * Gets the default plans tab based on user permissions and available plans.
 * @param state - The Redux state
 * @returns The default tab index (ARTIST_PLANS_TAB or BUSINESS_PLANS_TAB)
 */
export const getDefaultPlansTab = state => {
  let index = BUSINESS_PLANS_TAB

  if (validatePlansPermissions[ARTIST_ID](state)) {
    index = ARTIST_PLANS_TAB
  }

  // if pre_populated_subscription_data contains only artist plan but user isn't on artist trial
  // added to avoid cases when billing page is empty
  if (isArtistPlansAvailable(state) && !isBusinessPlansAvailable(state)) {
    index = ARTIST_PLANS_TAB
  }

  return index
}
